export const schoolsReducer = (state = {loading: true, resultschool: null, schools: null, school: null, schooluser: null, schoolsprovinces: null, paymentMethods: null, resultPaymentMethod: null, errorPaymentMethod: null} , action) => {
    switch (action.type) {
        case 'SCHOOL_GETALL_SUCCESS':
            return {
                ...state,
                loading:false,
                schools: action.payload
            }
        case 'SCHOOL_GETPROVINCES_SUCCESS':
            return {
                ...state,
                loading:false,
                schoolsprovinces: action.payload
            }
        case 'SCHOOL_GET_SUCCESS':
            return {
                ...state,
                loading:false,
                school: action.payload.school,
                schooluser: action.payload.schooluser
            }
        case 'SCHOOL_ADDCANDIDATE_SUCCESS':
            return {
                ...state,
                loading:false,
                resultschool: action.payload
            }
        case 'SCHOOL_ADDCANDIDATE_ERROR':
            return {
                ...state,
                loading:false,
                resultschool: action.payload
            }
        case 'SCHOOL_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'SCHOOL_RESET_RESULT':
            return {...state,
                resultschool: null
            }
        case 'SCHOOL_NOT_LOADING':
            return {
                ...state,
                loading:false
            }
        case 'SCHOOL_GET_PAYMENTMETHODS_SUCCESS':
            return {
                ...state,
                loading: false,
                paymentMethods: action.payload
            }
        case 'SCHOOL_ADD_PAYMENTMETHODS_SUCCESS':
            return {
                ...state,
                loading: false,
                resultPaymentMethod: action.payload,
                errorPaymentMethod: null
            }
        case 'SCHOOL_ADD_PAYMENTMETHODS_RESET':
            return {
                ...state,
                resultPaymentMethod: null
            }
        case 'SCHOOL_REMOVE_PAYMENTMETHODS_SUCCESS':
            return {
                ...state,
                loading: false,
                resultPaymentMethod: action.payload
            }
        case 'SCHOOL_ADD_PAYMENTMETHODS_ERROR':
            return {
                ...state,
                loading: false,
                errorPaymentMethod: action.payload
            }
        default:
            return state
    }
}

